import { usePerms } from 'contexts/PermsContext';
import FemaCredentialsFeature from 'features/FemaCredentials/index.web';
import { FEMA_PERMISSIONS } from 'features/Weather/features/WeatherAlerts/features/AlertCreator/components/IpawsAlertFields/config/Ipaws.config';
import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

/** The access levels that can open a Settings page; the permission key still applies. */
const FEMA_CREDENTIALS_ACCESS_LEVELS = [8, 9, 10, 11, 12, 13];

/**
 * FE-11: the client credential page at `/system/femacredentials`, gated on the STRICT key
 * `ManageFemaCredentials` (no super-user bypass). The server check comes first; without the key
 * the page goes to `/404`. Pattern: `pages/Weather/FemaAlerts.tsx`.
 */
const FemaCredentials = () => {
  const perms = usePerms();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!(await perms.validatePermissions([FEMA_PERMISSIONS.credentials]))) {
        navigate('/404');
      }
    })();
  }, [navigate, perms]);

  if (!perms.testPermission(FEMA_CREDENTIALS_ACCESS_LEVELS, [FEMA_PERMISSIONS.credentials])) {
    return null;
  }

  return (
    <Container fluid className="py-3">
      <FemaCredentialsFeature />
    </Container>
  );
};

export default FemaCredentials;
